import ManageRewards from './ManageRewards/index'
export default ManageRewards
